//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Join.js";
import "../no/TaggedObject.js";
import "../no/SelectTaggedObject.js";
import "../no/SelectObject.js";
let d=[[[0,"Filter",1,0],[0,"GroupResults",1,0],[1,"ReassignBody",0,"SelectTaggedObject",0]],[[["nodeTag"],"CenterNode",{},1,0],[["selectObjectTag"],"RemoveBodyNode",{},1,0],[["nodeTag"],"DeleteNode",{},1,0],[[],"SaveAllTree",{},0,0],[[],"ClearAllTree",{},0,0],[["joinFeatureTag","numSelectObjects","selectObjects"],"FeatureSelectObjects",{},1,0],[["joinFeatureTag","isModified"],"MarkFeatureModified",{},2,0],[["ownerTag","nodeTag"],"ReassignBodyNode",{},2,0],[["joinFeature","numberBodyCollectors"],"GetBodies",{R_:{bodyCollectors:"ScCollector[]"}},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Join.JoinedFinderBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Join.JoinedFinderBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Join.JoinedFinderBuilder.FilterTypes = Object.freeze({
    "All" : "All", "Passed" : "Passed", "Warning" : "Warning", "Failed" : "Failed", "Saved" : "Saved", "NotSaved" : "NotSaved", "Deleted" : "Deleted"});

export default SPLM;